<template>
  <div class="login">
    <!-- <div class="banner">
      <img src="../assets/images/login_banner.png" alt="" />
    </div> -->
    <div class="logo_head flex-colc">
      <div class="logo_tit flex-rowc">
        <img src="../assets/images/logo_tit.png" alt="" />
      </div>
      <p>[ SPR Plus 跨境新零售&供销存一体化管理服务平台 ]</p>
      <p class="txt">标准版</p>
    </div>

    <div class="form_data">
      <div class="tit">用户登录</div>
      <!-- <div class="tit">选择您的登录身份</div> -->
      <div class="input_box">
        <van-field v-model="name" placeholder="请输入手机号码" />
      </div>
      <div class="input_box">
        <van-field :type="pwdType" v-model="pwd" placeholder="密码" @keyup.enter="handleLogin" />
        <div class="visual" @click="handleVisualPwd">
          <i
            class="iconfont"
            :class="
              pwdType == 'password' ? 'icon-icon_xianshi' : 'icon-xianshi'
            "
          ></i>
        </div>
      </div>
      <div class="btn login" @click="handleLogin">登录</div>
      <div class="register">
        <p @click="handleGo(1)">忘记密码?</p>
      </div>
      <div class="btn" @click="handleGo(2)">注册新用户</div>

      <div class="copy_web_wrap">
        <div
          class="btn copy_box"
          data-clipboard-text="https://sprdevweb.winksshowp.com"
          @click="handleCopyBtn"
        >
          一键复制Web链接
        </div>
        <p>
          点击“一键复制后Web链接”按钮后 <br />
          前往浏览器地址栏粘贴使用
        </p>
      </div>
    </div>

    <van-popup :round="true" v-model="isShowReg" @click="isShowReg = false">
      <div class="register_popup">
        <div class="img">
          <img src="../assets/images/register_ercode_new.png" alt="" />
        </div>
        <div class="txt">请长按扫码<br />进入小程序后授权注册</div>
      </div>
    </van-popup>

    <!-- 验证码 -->
    <van-overlay :show="isShow" @click="isShow = false"> </van-overlay>
    <div class="popup_box" v-if="isShow" @click.self="isShow = false">
      <div class="popup_wrapper">
        <div class="popup_header flex-between">
          <div class="tit">请完成安全验证</div>
          <van-icon name="cross" @click="isShow = false" />
        </div>
        <div class="popup_content flex-rowc">
          <div class="verify-wrap">
            <Verify
              :type="3"
              :barSize="barSize"
              :showButton="false"
              @success="successVerify"
              @error="erroeVerify"
            ></Verify>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Clipboard from "clipboard";
import Verify from "vue2-verify";
import { userLogin, getUserInfo } from "../api/api";
export default {
  name: "login",
  components: { Verify },
  data() {
    return {
      isShow: false,
      barSize: {
        width: "100%",
        height: "40px",
      },
      isVerify: false, // 是否验证成功

      isShowLoad: true, // 默认为加载中

      isShowReg: false, // 是否显示注册弹窗
      pwdType: "password",
      name: "",
      pwd: "",
    };
  },
  computed: {
    ...mapState(["userAgent"]),
  },
  created() {},
  methods: {
    // 密码显示
    handleVisualPwd() {
      this.pwdType = this.pwdType == "password" ? "text" : "password";
    },
    handleGo(type) {
      if (type == 1) {
        this.$router.push("/password");
      } else if (type == 2) {
        this.$router.push("/register");
      }
    },
    // 滑动验证码成功
    successVerify() {
      this.isVerify = true;
      this.userSubmit();
    },
    // 拖动滑块失败
    erroeVerify(obj) {
      this.verify = false;
      this.code = "";
      obj.refresh();
    },

    handleLogin() {
      let { name, pwd } = this;
      if (name == "") {
        this.$toast("请输入手机号码");
        return;
      }
      if (pwd == "") {
        this.$toast("请输入密码");
        return;
      }
      this.isShow = true;
    },

    userSubmit() {
      let { name, pwd } = this;
      let qywx_userid =
        this.$store.state.qy_userId == 0 ? "" : this.$store.state.qy_userId;
      let params = {
        usertype: 1, // 1 个人用户 2 企业用户
        loginname: name,
        loginpwd: pwd,
        qywx_userid,
      };
      this.isShow = false;
      const toast = this.$toast.loading({
        message: "登录中...",
        forbidClick: true,
      });
      userLogin(params).then((res) => {
        toast.clear();
        if (res.result) {
          this.$toast.success(res.message);
          this.$store.commit("updateOpenid", res.code);
          // setTimeout(() => {
          //   this.$router.push("/home");
          // }, 1500);
          this.getUserInfo(res.code);
        } else {
          this.$toast.fail(res.message || "接口失效，请稍后～");
        }
      });
    },

    getUserInfo(openid) {
      getUserInfo({ openid: openid }).then((res) => {
        if (Object.keys(res).length > 0) {
          this.$store.commit("updateUserInfo", res);
          this.$store.commit("setUserLoginType", 0);
          if (res.mobile) {
            setTimeout(() => {
              this.$router.push("/home");
            }, 1500);
          } else {
            setTimeout(() => {
              this.$router.push("/guide");
            }, 1500);
          }
        }
      });
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },
  },
};
</script>
<style lang='less' scoped>
.logo_head {
  padding: 60px 0 35px;
  margin: 0 75px;
  border-bottom: 1px dashed #020202;
  .logo_tit {
    width: 460px;
    margin-bottom: 28px;
  }
  p {
    font-size: 20px;
    color: #000000;
    &.txt {
      font-size: 30px;
      color: #f30033;
      font-weight: bold;
      margin-top: 23px;
    }
  }
}

.form_data {
  padding: 68px 70px 0;
  font-size: 30px;

  .tit {
    text-align: center;
    color: #444444;
    margin-bottom: 65px;
  }
  .radio_group {
    margin: 68px auto 110px;
  }
  .input_box {
    margin-bottom: 60px;
    input {
      text-align: center;
    }
    .visual {
      position: absolute;
      top: 50%;
      right: 30px;
      transform: translateY(-50%);
      .iconfont {
        font-size: 38px;
        color: #818181;
      }
    }
  }
  // .verify-wrap {
  //   width: 500px;
  //   margin: 0 auto 90px;
  //   font-size: 20px;
  // }

  .register {
    text-align: center;
    margin: 55px 0 50px;
    font-size: 26px;
    p {
      width: 200px;
      color: #464646;
      font-size: 24px;
      margin: 0 auto 55px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .btn {
    width: 300px;
    height: 70px;
    line-height: 70px;
    text-align: center;
    border-radius: 35px;
    font-size: 24px;
    color: #333333;
    border: 1px solid #999999;
    margin: auto;
    &.login {
      background: #f62560;
      color: #fff;
    }
  }
  .copy_web_wrap {
    margin-top: 90px;
    p {
      font-size: 22px;
      color: #f30033;
      text-align: center;
      margin-top: 30px;
      line-height: 30px;
    }
  }
}
.register_popup {
  width: 500px;
  padding: 30px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 10px;
  .img {
    width: 440px;
    height: 440px;
  }
  .txt {
    margin-top: 40px;
    font-size: 28px;
    text-align: center;
  }
}
.van-popup {
  z-index: 100001 !important;
}

.verify-wrap {
  width: 500px;
  font-size: 20px;
}
.popup_box {
  height: 100vh;
  top: 0;
  position: fixed;
  z-index: 999999999999;
  width: 100%;
  .popup_wrapper {
    width: 550px;
    box-sizing: border-box;
    background: #fff;
    top: 34%;
    margin: auto;
    position: relative;
    z-index: 9999999999;
    .popup_header {
      height: 110px;
      padding: 0 20px;
      font-size: 32px;
      box-sizing: border-box;
    }
    .popup_content {
      padding: 25px 0 70px;
      position: relative;
    }
  }
}
.wx_register {
  font-size: 28px;
  color: #333333;
  width: 600px;
  height: 110px;
  border: 1px solid #aaaaaa;
  margin: 50px auto 0;
  .icon {
    width: 43px;
    height: 35px;
    margin-right: 28px;
  }
}
</style>